import { useMutation } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import { selectAuthToken } from 'selectors';
import {
  getMembersForExportApi,
  GetMembersForExportResponse,
  GetMembersForExportErrorResponse,
} from 'TeamModule/services/GetMembersForExportApi';
import { AxiosResponse } from 'axios';
import { SearchMembersByFieldsPayload } from 'TeamModule/api/searchMembersByFieldsApi';
import { useContextHeaders } from 'hooks/useContextHeaders';

export const useMembersForExportMutation = ({
  onSuccess,
}: {
  onSuccess?: (response: AxiosResponse<GetMembersForExportResponse>) => void;
} = {}) => {
  const token = useSelector(selectAuthToken);
  const { buildConfig } = useContextHeaders();

  const mutation = useMutation<
    AxiosResponse<GetMembersForExportResponse>,
    AxiosResponse<GetMembersForExportErrorResponse>,
    SearchMembersByFieldsPayload
  >({
    mutationFn: async (params) => {
      if (!token) throw new Error('No auth token available');
      // buildConfig() automatically includes URL context headers (tenant/realmId)
      return getMembersForExportApi({ params, token, config: buildConfig() }) as Promise<
        AxiosResponse<GetMembersForExportResponse>
      >;
    },
    onSuccess,
  });

  return {
    exportMembers: mutation.mutate,
    isExportingMembers: mutation.isPending,
  };
};

export default useMembersForExportMutation;
